export const init = () => {
  if (document.querySelector('.js-dynamic-box')) {
    const imageBoxes = document.querySelectorAll('.js-dynamic-box');
    imageBoxes.forEach((box) => {
      if (box.classList.length == 2) {
        try {
          const titleWidth = box.querySelector('.js-dynamic-box-text').offsetWidth;
          const imageWidth = box.querySelector('.js-dynamic-box-image').getAttribute('width');
          if (titleWidth >= imageWidth) {
            box.style.maxWidth = `${Number(titleWidth) + 51}px`;
          }
          else {
            box.style.maxWidth = `${Number(imageWidth) + 2}px`;
          }
        }
        catch (e) {
          console.log('Exception thrown: ' + e);
        }
      }
    });
  }
}